<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h3>{{formTitle}}</h3>
      </v-flex>
      <v-flex xs12>
        <v-tabs>
          <v-tab href="#tab-1">
            Основные данные
          </v-tab>
          <v-tab-item
                  :value="'tab-1'">
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm8>
                      <v-text-field
                              v-model.trim="service.date_hemodialysis"
                              type="date"
                              label="Дата процедуры гемодиализа"
                              :error-messages="requiredErrors('date_hemodialysis')"
                              @blur="$v.service.date_hemodialysis.$touch()"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab href="#tab-2">
            Системные данные
          </v-tab>
          <v-tab-item
                  :value="'tab-2'">
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                        <table>
                            <tr>
                                <th>Код</th>
                                <td>{{service.id}}</td>
                            </tr>
                            <tr>
                                <th>Пользователь</th>
                                <td>{{service.username}}</td>
                            </tr>
                            <tr>
                                <th>Дата создания</th>
                                <td>{{ service.create_date|date_time }}</td>
                            </tr>
                            <tr>
                                <th>Дата модификации</th>
                                <td>{{ service.date_change|date_time }}</td>
                            </tr>
                            <tr>
                                <th>Итог сверки</th>
                                <td>{{ service.result }}</td>
                            </tr>

                        </table>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.native="save">Сохранить</v-btn>
              <v-btn
                      v-if="!service.result && this.$route.params.service_id !== 'new'"
                      @click.native="del">Удалить</v-btn>
              <v-btn @click.native="cancel">Отменить</v-btn>
          </v-card-actions>
      </v-flex>

        <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {

    }
  },
  mixins: [validationMixin],
  validations: {
    // name: { required, maxLength: maxLength(10) },
    service: {
      date_hemodialysis: { required }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    service () {
      return this.$store.getters['hemodialysisService/service']
    },
    formTitle () {
      return this.$route.params.service_id === 'new' ? 'Добавить услугу' : 'Услуга'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      let id = this.$route.params.service_id
      if (id === 'new') {
        this.$store.commit('hemodialysisService/setDefaultService')
      } else {
        this.$store.dispatch('hemodialysisService/fetchService', {
          id: id })
      }
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$set(this.service, 'person', this.$route.params.person_id)
        this.$store.dispatch('hemodialysisService/insertService', this.service)
          .then(() => {
            this.$router.push({ name: 'hemodialysis_service',
              params: {
                'person_id': this.$route.params.person_id,
                'service_id': this.service.id
              } })
          }
          )
      }
    },
    del () {
      if (this.service.id !== 'new') {
        this.$store.dispatch('hemodialysisService/deleteService', this.service.id)
          .then(() => {
            this.$router.push({ name: 'hemodialysis_services' })
          })
      }
    },
    cancel () {
      // this.initialize()
      this.$router.push({ name: 'hemodialysis_services' })
    },
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.service[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('email')) {
        !field.email && errors.push('Это не адрес электронной почты')
      }
      if (field.hasOwnProperty('validatorRus')) {
        !field.validatorRus && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorPhone')) {
        !field.validatorPhone && errors.push('Некорректные символы')
      }
      return errors
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
</style>
